import React from "react";
import Header from "../containers/Header";
import CreateAccount from "../components/CreateAccount/CreateAccount";

function Register() {
  return (
    <React.Fragment>
      <Header />
      <CreateAccount />
    </React.Fragment>
  );
}
export default Register;
